<template>
<m-pageframe
    title="RedChirp Net Revenue Retention (NRR)"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickExport()"
                >
                    <v-list-item-title>Export to Excel...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

     <v-layout row wrap>
        <v-flex flex-grow-0>
            <m-boolean-search-filter
                style="margin-top: 5px; margin-left: 10px;"
                label="Include in NRR Calculation"
                v-model="filter_include"
                v-on:input='doUpdate'
            />
        </v-flex>

        <v-flex flex-grow-0>
            <m-boolean-search-filter
                style="margin-top: 5px; margin-left: 10px;"
                label="Include Archived"
                v-model="filter_archived"
                v-on:input='doUpdate'
            />
        </v-flex>
     </v-layout>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.include_in_nrr_calculation="{ item }">
            <v-simple-checkbox disabled :value="item.include_in_nrr_calculation"/>
        </template>

        <template v-slot:item.is_archived="{ item }">
            <v-simple-checkbox disabled :value="item.is_archived"/>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickEdit(item)"
                >
                    <v-list-item-title>Edit Settings...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <m-nrr-settings-dialog
        ref="edit-dialog"
        v-on:change="doUpdate"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            full_text: null,
            results: null,
            filter_include: null,
            filter_archived: null,

            headers: [
                { text: 'Organization', value: 'organization_label'},
                { text: 'Industry', value: 'industry'},
                { text: 'Include in NRR Calculation', value: 'include_in_nrr_calculation'},
                { text: 'Archived', value: 'is_archived'},
                { text: 'Cancellation Reason', value: 'cancellation_reason'},
                { text: 'Notes', value: 'notes'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/red-chirp-revenue/nrr',
            
                'params' : {
                        'full_text': this.full_text,
                        'include_in_nrr_calculation': this.filter_include,
                        'is_archived': this.filter_archived,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list NRR settings',
            });
        },
        

        onClickExport() {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/organizations/mrr',
                    {
                    }
                );
        },

        onClickEdit(item)
        {
            this.$refs['edit-dialog'].showDialog(item);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>

<!--


	final private Optional<String> notes;
	

-->